import { gsap } from 'gsap';
export const divMover = function (propz) {
  let mrDiv = null;

  if (propz.id) {
    mrDiv = document.getElementById(propz.id);
  } else if (propz.selector) {
    mrDiv = document.querySelector(propz.selector);
  } else {
    console.error("DivMover: No selector or id provided");
  }

  propz.position = propz.position || "absolute";
  propz.container.appendChild(mrDiv);
  delete propz.container;

  gsap.set(mrDiv, propz);
  return mrDiv;
};

export const canMaker = function (propz) {
  const mrCan = document.createElement("canvas");

  propz.position = propz.position || "absolute";

  if (propz.container) {
    propz.container.appendChild(mrCan);
    delete propz.container;
  } else {
    console.error("canMaker: you forgot the container dude!");
  }

  if (propz.svgSrc) {
    canvg(mrCan, propz.svgSrc);
    delete propz.svgSrc;
  } else {
    console.error("canMaker: svg source is needed!");
  }

  gsap.set(mrCan, propz);
  return mrCan;
};

export const divMaker = function (propz, elType) {
  elType = elType || "div";
  const mrDiv = document.createElement(elType);
  propz.position = propz.position || "absolute";

  propz.container.appendChild(mrDiv);
  delete propz.container;

  if (propz.imgClass)
    mrDiv.className = "spriteness spriteness-" + propz.imgClass;
  delete propz.imgClass;

  gsap.set(mrDiv, propz);
  return mrDiv;
};

export const imgMaker = function (propz) {
  const mrImg = document.createElement("img");

  propz.position = propz.position || "absolute";

  propz.container.appendChild(mrImg);
  delete propz.container;

  mrImg.src = propz.imgSrc;

  if (propz.retina) {
    const dimensions = setImgSize(mrImg, propz.imgSrc);
    console.log("propz.imgSrc: " + propz.imgSrc);
    delete propz.retina;
  }

  delete propz.imgSrc;

  gsap.set(mrImg, propz);
  return mrImg;
};





export function setImgSize(img, relSrc) {
  img.onload = function () {
    gsap.set('[src*="' + relSrc + '"]', {
      width: img.width / 2,
      height: img.height / 2,
    });
  };
}

export const maskMaker = function (el) {
  const children = el.childNodes;
  const masks = [];
  for (let i = 0; i < children.length; i++) {
    const mask = document.createElement("div");

    mask.className = "masky";
    masks.push(mask);

    const top =
      children[i].getBoundingClientRect().bottom -
      el.getBoundingClientRect().top;
    const left = -el.getBoundingClientRect().left;
    const width = children[i].offsetWidth;
    const height = children[i].offsetHeight * 4;

    gsap.set(children[i], { zIndex: i });
    gsap.set(mask, {
      zIndex: i,
      top: top,
      left: left,
      width: bWidth,
      height: height,
    });
  }

  for (let a = 0; a < masks.length; a++) {
    el.appendChild(masks[a]);
  }
};

export const duplicate = function (el, container, props) {
  const clone = el.cloneNode(true); // "deep" clone
  container.appendChild(clone);
  if (props) {
    gsap.set(clone, props);
  }
  return clone;
};
